var _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
function SvgSireGoingStrikeRate(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M13.54 9.78V5H20v1.43h-5.02v8.14H20V16h-6.46v-4.8H7.88V9.78zm-6.38 4.45c-.6.2-1.68.46-2.7.46-1.56 0-2.6-.4-3.32-1.06C.38 12.92 0 11.9 0 10.77c.01-2.74 2.05-4.13 4.6-4.13 1.06 0 1.87.2 2.28.4l-.4 1.66c-.44-.2-.97-.33-1.87-.33-1.3 0-2.38.68-2.38 2.28 0 1.47.95 2.33 2.25 2.33a2.9 2.9 0 00.66-.07v-1.36H4.07V9.93h3.1v4.3z",
    fill: "#010101"
  })));
}
export default SvgSireGoingStrikeRate;